import React, { Component } from 'react'
import { connect } from 'react-redux'
import { deleteMarker } from '../../../../store/actions/sketchActions';

class FloorMarkerListDeleteModal extends Component {

    handleClick = (proid, markerid) => {
        // console.log(proid,markerid)
        this.props.deleteMarker(proid, markerid);

    }

    render() {
        const {modalTitleStyle, modalInfoTextStyle, proid, markerid } = this.props;

        return (
            <div className="dynamicModalContainer">
                <div className="dynamicModalSm">
                    <p style={modalTitleStyle}>Are you sure?</p>
                    <p style={modalInfoTextStyle}>You are about to delete this tag. Press confirm to delete</p>
                    <br />
                    <div className="btn btn-danger btn-sm" style={{ float: "right", borderRadius: '7px' }} onClick={() => { this.handleClick(proid, markerid) }}>Confirm</div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        alu: state.alu,
        floor: state.floor,

        formLabelStyle: state.appControl.formLabelStyle,
        modalStyles: state.appControl.modalStyles,
        modalWidth: state.appControl.modalWidth,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,

        companyData: state.firestore.data.Company,

        userId: state.firebase.auth.uid,
        companyBriefingsData: state.firestore.data.CompanyBriefings,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        deleteMarker: (proid, markerid) => dispatch(deleteMarker(proid, markerid)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FloorMarkerListDeleteModal)
